import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';

import { VOFilters, VOApiFilterType } from '../../types';
import { useFiltersOptions } from 'modules/vendorOpportunity/list/api/useFiltersOptions';
import { Stack } from '@mui/material';

export const BPFManager = () => {
  const { control } = useFormContext<VOFilters>();

  const { options, loading } = useFiltersOptions([VOApiFilterType.BPF_STAGE, VOApiFilterType.BPF_DEPARTMENT]);

  const stagesOptions =
    options?.find(o => o.group === VOApiFilterType.BPF_STAGE)?.list?.map(({ label, value }) => ({ label, value })) ??
    [];
  const departmentsOptions =
    options
      ?.find(o => o.group === VOApiFilterType.BPF_DEPARTMENT)
      ?.list?.map(({ label, value }) => ({ label, value })) ?? [];

  return (
    <Stack gap="1rem">
      <AutocompleteField
        multiple
        size="small"
        name="BPF.departments"
        loading={loading}
        control={control}
        disableCloseOnSelect
        options={departmentsOptions}
        disabled={!departmentsOptions.length}
        textFieldProps={{
          size: 'small',
          label: 'Department',
          variant: 'outlined',
        }}
      />
      <AutocompleteField
        multiple
        size="small"
        name="BPF.stages"
        loading={loading}
        control={control}
        disableCloseOnSelect
        options={stagesOptions}
        disabled={!stagesOptions.length}
        textFieldProps={{
          size: 'small',
          label: 'Stage',
          variant: 'outlined',
        }}
      />
    </Stack>
  );
};
